<template>
  <a-space v-if="!is_massage_default">
    <a-button
      type="link"
      v-if="is_show_normal_search"
      @click="handleShowSearchRender"
    >
      {{ $t('普通') }}
    </a-button>
    <a-button
      v-if="!isShowForm"
      type="link"
      @click="
        () => {
          isShowForm = true;
          $emit('resize');
        }
      "
    >
      <span class="expand-btn">{{ $t('展开') }}</span>
    </a-button>
    <a-button
      v-else
      type="link"
      @click="
        () => {
          isShowForm = false;
          $emit('resize');
        }
      "
    >
      {{ $t('隐藏') }}
    </a-button>
  </a-space>
  <span v-show="!isShowForm">
    <span
      v-for="(item, index) in default_search_condition_config_list"
      :key="index"
    >
      <a-tag>{{ $t('条件组') }}{{ index + 1 }}:</a-tag>
      <span
        v-for="condition in item"
        :key="condition.field_name"
      >
        <a-tag
          v-show="isShowSearchTag(index, condition)"
          color="green"
        >
          {{ condition.label }}: {{ transferValueFunc(index, condition) }}
          <close-outlined
            style="cursor: pointer; margin-left: 5px"
            @click="handleDelSearch(index, condition.field_name)"
          />
        </a-tag>
      </span>
    </span>
  </span>
  <div
    v-if="delayShow || isShowForm"
    class="card"
    v-show="isShowForm"
  >
    <div
      v-for="(group_item, group_index) in default_search_condition_config_list"
      :key="group_index"
    >
      <div
        class="condition-group"
        v-if="default_search_condition_config_list.length > 1"
      >
        {{ $t('条件组') }} {{ group_index + 1 }}
      </div>
      <a-space
        :wrap="true"
        align="center"
        :size="0"
      >
        <a-space-compact
          block
          v-for="(condition, k) in group_item"
          :key="condition.field_name"
          size="middle"
          @mouseenter="handleMouseEnter(group_index, condition)"
          @mouseleave="handleMouseLeave(group_index, condition)"
        >
          <a-input-group compact>
            <a-tooltip :title="condition.label">
              <a-cascader
                :value="condition.label"
                style="width: 125px"
                :options="searchItemOptionsDict[group_index]"
                showSearch
                :allowClear="false"
                :placeholder="$t('请选择...')"
                @change="value => onChangeSearchItem(value, group_index, condition, k)"
              />
            </a-tooltip>
            <a-tooltip :title="get_operator_type_map(condition.format, condition.operator)">
              <a-select
                v-if="get_operator_list_selected(condition).length > 0"
                :dropdownMatchSelectWidth="false"
                v-model:value="condition.operator"
                @change="value => onChangeOperator(value, group_index, condition)"
                style="width: 100px"
              >
                <a-select-option
                  v-for="item in get_operator_list_selected(condition)"
                  :value="item"
                  :key="item"
                >
                  {{ get_operator_type_map(condition.format, item) }}
                </a-select-option>
              </a-select>
            </a-tooltip>
            <span
              style="width: 315px; height: 40px"
              v-if="condition_model_dict && condition_model_dict[group_index]"
            >
              <template
                v-if="['is_or_not_blank_or_null', 'is_or_not_null'].includes(condition.operator)"
              >
                <field-render-2
                  :is_show_label="false"
                  v-model:label="labelModel[condition.field_name]"
                  v-model:value="condition_model_dict[group_index][condition.field_name]"
                  :field="{
                    ...condition,
                    type: 'select',
                    mode: 'default',
                    format: 'choices',
                    class_name: 'str',
                    placeholder: '',
                  }"
                  :formModel="condition_model_dict[group_index]"
                  :options="is_or_not_blank_or_null_options"
                  :validateInfos="validateInfos"
                />
              </template>
              <template v-else-if="['input'].includes(condition.format)">
                <template
                  v-if="condition.operator === 'between' || condition.operator === 'notbetween'"
                >
                  <template v-if="condition.type === 'datepicker'">
                    <field-render-2
                      :is_show_label="false"
                      v-model:label="labelModel[condition.field_name]"
                      v-model:value="condition_model_dict[group_index][condition.field_name]"
                      :field="{ ...condition, type: 'rangepicker', format: condition.dateFormat }"
                      :formModel="condition_model_dict[group_index]"
                      :options="condition.options"
                      :validateInfos="validateInfos"
                    />
                  </template>
                  <template v-else-if="condition.type === 'monthpicker'">
                    <field-render-2
                      :is_show_label="false"
                      v-model:label="labelModel[condition.field_name]"
                      v-model:value="condition_model_dict[group_index][condition.field_name]"
                      :field="{
                        ...condition,
                        type: 'monthrangepicker',
                        format: condition.dateFormat,
                      }"
                      :formModel="condition_model_dict[group_index]"
                      :options="condition.options"
                      :validateInfos="validateInfos"
                    />
                  </template>
                  <template v-else-if="condition.type === 'timepicker'">
                    <field-render-2
                      :is_show_label="false"
                      v-model:label="labelModel[condition.field_name]"
                      v-model:value="condition_model_dict[group_index][condition.field_name]"
                      :field="{
                        ...condition,
                        type: 'timerangepicker',
                        format: condition.dateFormat,
                      }"
                      :formModel="condition_model_dict[group_index]"
                      :options="condition.options"
                      :validateInfos="validateInfos"
                    />
                  </template>
                  <template v-else>
                    <a-flex>
                      <field-render-2
                        :is_show_label="false"
                        v-model:label="labelModel[condition.field_name]"
                        v-model:value="condition_model_dict[group_index][condition.field_name][0]"
                        :field="condition"
                        :formModel="condition_model_dict[group_index]"
                        :options="condition.options"
                        :validateInfos="validateInfos"
                      />
                      <div class="range">~</div>
                      <field-render-2
                        :is_show_label="false"
                        v-model:label="labelModel[condition.field_name]"
                        v-model:value="condition_model_dict[group_index][condition.field_name][1]"
                        :field="condition"
                        :formModel="condition_model_dict[group_index]"
                        :options="condition.options"
                        :validateInfos="validateInfos"
                      />
                    </a-flex>
                  </template>
                </template>
                <template v-else-if="condition.operator === '_eq'">
                  <field-render-2
                    :is_show_label="false"
                    v-model:label="labelModel[condition.field_name]"
                    v-model:value="condition_model_dict[group_index][condition.field_name]"
                    :field="{
                      ...condition,
                      type: 'select',
                      mode: 'default',
                      format: 'choices',
                      class_name: 'str',
                      placeholder: '',
                    }"
                    :formModel="condition_model_dict[group_index]"
                    :options="options_eq"
                    :validateInfos="validateInfos"
                  />
                </template>
                <template
                  v-else-if="
                    condition.type === 'datepicker' ||
                    condition.type === 'monthpicker' ||
                    condition.type === 'timepicker'
                  "
                >
                  <field-render-2
                    :is_show_label="false"
                    v-model:label="labelModel[condition.field_name]"
                    v-model:value="condition_model_dict[group_index][condition.field_name]"
                    :field="{ ...condition, format: condition.dateFormat }"
                    :formModel="condition_model_dict[group_index]"
                    :options="condition.options"
                    :validateInfos="validateInfos"
                  />
                </template>
                <template v-else>
                  <field-render-2
                    :is_show_label="false"
                    v-model:label="labelModel[condition.field_name]"
                    v-model:value="condition_model_dict[group_index][condition.field_name]"
                    :field="condition"
                    :formModel="condition_model_dict[group_index]"
                    :options="condition.options"
                    :validateInfos="validateInfos"
                  />
                </template>
              </template>
              <template v-else-if="['choices', 'remote'].includes(condition.format)">
                <template v-if="condition.format === 'choices'">
                  <field-render-2
                    :is_show_label="false"
                    v-model:label="labelModel[condition.field_name]"
                    v-model:value="condition_model_dict[group_index][condition.field_name]"
                    :field="condition"
                    :formModel="condition_model_dict[group_index]"
                    :options="condition.options"
                    :validateInfos="validateInfos"
                  />
                </template>
                <template v-else-if="condition.format === 'remote'">
                  <field-render-2
                    :is_show_label="false"
                    v-model:label="labelModel[condition.field_name]"
                    v-model:value="condition_model_dict[group_index][condition.field_name]"
                    :field="{ ...condition, name: condition?.field_name }"
                    :formModel="condition_model_dict[group_index]"
                    :options="condition.options"
                    :validateInfos="validateInfos"
                  />
                </template>
              </template>
            </span>
            <span
              class="close-icon"
              v-if="deleteBtnDict && deleteBtnDict[group_index]"
            >
              <a-tooltip
                title="删除此条件"
                v-if="
                  deleteBtnDict[group_index][condition.field_name] &&
                  (default_search_condition_config_list[0].length > 1 ||
                    default_search_condition_config_list.length > 1) &&
                  !is_massage_default
                "
              >
                <close-circle-outlined @click="handleDeleteFormItem(group_index, condition)" />
              </a-tooltip>
            </span>
          </a-input-group>
        </a-space-compact>
      </a-space>
      <a-divider
        class="divider"
        style="margin: 0"
        v-if="
          default_search_condition_config_list.length > 1 &&
          group_index != default_search_condition_config_list.length - 1
        "
      >
        或
      </a-divider>
    </div>
  </div>
  <div
    class="search-bar"
    v-if="isShowForm && !is_massage_default"
  >
    <a-space>
      <a-button
        size="small"
        type="primary"
        @click="handleAddConditions"
      >
        {{ $t('添加条件') }}
      </a-button>
      <a-button
        size="small"
        type="primary"
        @click="handleAddGroupCondition"
      >
        {{ $t('添加条件组') }}
      </a-button>
      <a-button
        size="small"
        type="primary"
        @click="handleSearch"
      >
        {{ $t('查询') }}
      </a-button>
    </a-space>
  </div>

  <add-condition-modal
    v-if="addConditionModal.open"
    :open="addConditionModal.open"
    :default_search_condition_config_list="default_search_condition_config_list"
    :base_search_condition_config_list="base_search_condition_config_list"
    @ok="handleAddConditionOk"
    @cancel="handleAddConditionCancel"
  />

  <add-condition-group-modal
    v-if="addConditionGroupModal.open"
    :open="addConditionGroupModal.open"
    :default_search_condition_config_list="default_search_condition_config_list"
    :base_search_condition_config_list="base_search_condition_config_list"
    @ok="handleAddGroupConditionOK"
    @cancel="handleAddGroupConditionCancel"
  />
</template>
<script lang="ts">
import {
  defineComponent,
  onMounted,
  reactive,
  ref,
  computed,
  watch,
  PropType,
  nextTick,
  onUnmounted,
} from 'vue';
import FieldRender from 'liyu-pc-base/components/FormRender/FieldRender.vue';
import AddConditionModal from 'liyu-pc-base/components/FormRender/GeneralFilter/AddConditionModal/index.vue';
import AddConditionGroupModal from 'liyu-pc-base/components/FormRender/GeneralFilter/AddConditionGroupModal/index.vue';
import { isNotEmpty } from 'liyu-pc-base/utils/function';
import {
  CloseCircleOutlined,
  CloseOutlined,
  LeftOutlined,
  RightOutlined,
} from '@ant-design/icons-vue';
import { useI18n } from 'vue-i18n';
import { get_options_eq } from 'liyu-pc-base/components/FormRender/GeneralFilter/data';
import moment from 'moment';
import FieldRender2 from 'liyu-pc-base/components/FormRender/FieldRender2.vue';
import { get_operator_type_map } from 'liyu-pc-base/utils/function';

export default defineComponent({
  name: 'GeneralFilter',
  props: {
    base_search_condition_config_list: {
      type: Array as PropType<any[]>,
    },
    default_search_condition_config_list: {
      type: Array as PropType<any[]>,
    },
    is_show_normal_search: {
      type: Boolean,
      default: () => false,
    },
    is_clear_model: {
      type: Boolean,
      default: () => false,
    },
    is_show_advantage: {
      type: Boolean,
      default: () => false,
    },
    is_massage_default: {
      type: Boolean,
      default: () => false,
    },
    eventBus: {
      type: Object,
      required: false,
    },
    delayShow: {
      type: Boolean,
      default: () => true,
    },
  },
  components: {
    FieldRender2,
    CloseOutlined,
    LeftOutlined,
    RightOutlined,
    FieldRender,
    AddConditionGroupModal,
    AddConditionModal,
    CloseCircleOutlined,
  },
  emits: [
    'search',
    'resize',
    'update_default_search_condition_config_list',
    'onShowSearchRender',
    'delSearch',
    'onChangeValue',
    'update:is_clear_model',
  ],
  setup(props, { emit }) {
    const isShowForm = ref(props.is_massage_default);
    const labelModel = ref({});
    const { t } = useI18n();
    const { options_eq } = get_options_eq(t);
    //条件组-->
    const condition_model_dict = ref([]);
    const validateInfos = {};
    const source_default_search_condition_config_list = ref(null);
    const is_or_not_blank_or_null_options = ref([
      { value: 'yes', label: t('is_or_not_blank_or_null.yes') },
      { value: 'no', label: t('is_or_not_blank_or_null.no') },
    ]);
    if (!source_default_search_condition_config_list.value) {
      source_default_search_condition_config_list.value = JSON.parse(
        JSON.stringify(props.default_search_condition_config_list),
      );
    }

    const operator_type_count_map = {
      between: 2,
      gt: 1,
      lt: 1,
      gte: 1,
      lte: 1,
      in: 0,
      eq: 1,
      _eq: 1,
      contains: 1,
      icontains: 1,
      startswith: 1,
      istartswith: 1,
      endswith: 1,
      iendswith: 1,
      notbetween: 2,
      notin: 0,
      notcontains: 1,
      noticontains: 1,
      notstartswith: 1,
      notistartswith: 1,
      notendswith: 1,
      notiendswith: 1,
      not_eq: 1,
      not_blank_not_null: 1,
      json_list_not_blank_not_null: 1,
      json_list_is_blank_is_null: 1,
      is_or_not_blank_or_null: 1,
      is_or_not_null: 1,
    };
    const is2DArray = arr => {
      const [first] = [arr];
      return Array.isArray(first) && arr.every(subArray => Array.isArray(subArray));
    };
    let old_operator = null;
    const onChangeOperator = (operator, index, condition) => {
      //不同操作类型，设置不同的默认值
      // if (condition_model_dict.value[index][condition.field_name]) {
      //   return;
      // }
      const value = condition_model_dict.value[index][condition.field_name];
      if (get_operator_list_selected(condition).includes('_eq')) {
        if (operator == '_eq') {
          condition_model_dict.value[index][condition.field_name] = null;
          old_operator = operator;
          emit('onChangeValue', { model: condition_model_dict.value });
          return;
        } else if (old_operator == '_eq') {
          condition_model_dict.value[index][condition.field_name] = null;
          old_operator = operator;
          emit('onChangeValue', { model: condition_model_dict.value });
          return;
        }
      }
      if (get_operator_list_selected(condition).includes('not_blank_not_null')) {
        if (operator == 'not_blank_not_null') {
          condition_model_dict.value[index][condition.field_name] = '是';
          old_operator = operator;
          emit('onChangeValue', { model: condition_model_dict.value });
          return;
        } else if (old_operator == 'not_blank_not_null') {
          condition_model_dict.value[index][condition.field_name] = null;
          old_operator = operator;
          emit('onChangeValue', { model: condition_model_dict.value });
          return;
        }
      }
      if (
        get_operator_list_selected(condition).includes('is_or_not_blank_or_null') ||
        get_operator_list_selected(condition).includes('is_or_not_null')
      ) {
        if (operator == 'is_or_not_blank_or_null' || operator == 'is_or_not_null') {
          condition_model_dict.value[index][condition.field_name] = null;
          old_operator = operator;
          emit('onChangeValue', { model: condition_model_dict.value });
          return;
        } else if (old_operator == 'is_or_not_blank_or_null' || old_operator == 'is_or_not_null') {
          condition_model_dict.value[index][condition.field_name] = null;
          old_operator = operator;
          emit('onChangeValue', { model: condition_model_dict.value });
          return;
        }
      }
      if (value instanceof Array && is2DArray(value)) {
        // 级联类型，默认值默认清空
        condition_model_dict.value[index][condition.field_name] = undefined;
      } else if (operator_type_count_map[operator] == 1) {
        if (value instanceof Array) {
          const [first] = condition_model_dict.value[index][condition.field_name];
          if (isNotEmpty(first)) {
            condition_model_dict.value[index][condition.field_name] = first;
          } else {
            condition_model_dict.value[index][condition.field_name] = null;
          }
        } else {
          condition_model_dict.value[index][condition.field_name] = value ? value : null;
        }
        const is = options_eq.some(
          obj => obj.value === condition_model_dict.value[index][condition.field_name],
        );
        if (is) {
          condition_model_dict.value[index][condition.field_name] = null;
        }
      } else if (operator_type_count_map[operator] == 2) {
        if (condition_model_dict.value[index][condition.field_name] instanceof Array) {
          const [first, seconds] = condition_model_dict.value[index][condition.field_name];
          condition_model_dict.value[index][condition.field_name] = [first, seconds];
        } else if (condition_model_dict.value[index][condition.field_name]) {
          const first = condition_model_dict.value[index][condition.field_name];
          condition_model_dict.value[index][condition.field_name] = [first, null];
        } else {
          condition_model_dict.value[index][condition.field_name] = [null, null];
        }
        const is = options_eq.some(
          obj => obj.value === condition_model_dict.value[index][condition.field_name][0],
        );
        if (is) {
          condition_model_dict.value[index][condition.field_name] = [null, null];
        }
      } else { 
        condition_model_dict.value[index][condition.field_name] = undefined;
      }
      old_operator = operator;
      emit('onChangeValue', { model: condition_model_dict.value });
      // console.log('onChangeValue');
    };

    const addConditionModal = reactive({
      open: false,
    });
    const handleAddConditions = () => {
      addConditionModal.open = true;
    };
    const handleAddConditionOk = (data: any) => {
      props.default_search_condition_config_list.forEach((item: any, index: any) => {
        data.new_list.forEach((item1: any, index1: any) => {
          if (index == index1) {
            item.forEach((item2: any) => {
              item1.forEach((item3: any) => {
                if (item2.field_name == item3.field_name) {
                  item3.value = item2.value;
                  item3.operator = item2.operator;
                }
              });
            });
          }
        });
      });
      //保存后处理 new_list
      emit('update_default_search_condition_config_list', { new_list: data.new_list });
      // refreshCondition();
      addConditionModal.open = false;
    };
    const handleAddConditionCancel = () => {
      addConditionModal.open = false;
    };

    const addConditionGroupModal = reactive({
      open: false,
    });
    const handleAddGroupCondition = () => {
      addConditionGroupModal.open = true;
    };
    const handleAddGroupConditionOK = (data: any) => {
      props.default_search_condition_config_list.forEach((item: any, index: any) => {
        data.new_list.forEach((item1: any, index1: any) => {
          if (index == index1) {
            item.forEach((item2: any) => {
              item1.forEach((item3: any) => {
                if (item2.field_name == item3.field_name) {
                  item3.value = item2.value;
                  item3.operator = item2.operator;
                }
              });
            });
          }
        });
      });
      emit('update_default_search_condition_config_list', { new_list: data.new_list });
      // refreshCondition();
      addConditionGroupModal.open = false;
    };
    const handleAddGroupConditionCancel = () => {
      addConditionGroupModal.open = false;
    };
    const handleSearch = () => {
      isShowForm.value = false;
      console.log('condition_model_dict.value', condition_model_dict.value);
      emit('search', { model: condition_model_dict.value });
    };
    const refreshCondition = (update_all = false) => {
      if (props.base_search_condition_config_list.length == 0) {
        return;
      }
      props.default_search_condition_config_list?.forEach((item_list: any, index: number) => {
        deleteBtnDict[index] = {};
        if (!condition_model_dict.value[index]) {
          condition_model_dict.value[index] = {};
        }
        props.base_search_condition_config_list.forEach((i: any) => {
          i.group?.forEach((group_item: any) => {
            item_list.forEach((k: any) => {
              if (group_item.field_name == k.field_name) {
                const value = condition_model_dict.value[index][k.field_name];
                if (value == undefined || update_all) {
                  if (operator_type_count_map[k.operator] == 1) {
                    if (k.value !== undefined) {
                      condition_model_dict.value[index][k.field_name] = k.value;
                    } else {
                      condition_model_dict.value[index][k.field_name] = null;
                    }
                  } else if (operator_type_count_map[k.operator] == 2) {
                    if (k.value !== undefined) {
                      condition_model_dict.value[index][k.field_name] = k.value;
                    } else {
                      condition_model_dict.value[index][k.field_name] = [null, null];
                    }
                  } else if (operator_type_count_map[k.operator] == 0) {
                    if (k.value !== undefined) {
                      condition_model_dict.value[index][k.field_name] = k.value;
                    } else {
                      condition_model_dict.value[index][k.field_name] = [];
                    }
                  }
                }
                Object.assign(k, { ...group_item, operator: k.operator }); // 保持表单项原有选择的查询条件
                if (k.operator == 'eq' && k.mode != 'default') {
                  group_item.mode = 'default';
                  Object.assign(k, { model: 'default' });
                } else if (['in', 'notin'].includes(k.operator) && k.mode != 'multiple') {
                  group_item.mode = 'multiple';
                  Object.assign(k, { model: 'multiple' });
                }
              }
            });
          });
        });
      });
    };
    const onFilterChanged = () => {
      refreshCondition(true);
    };

    const deleteBtnDict = reactive({}); // 表单项的删除按钮是否显示
    const handleMouseEnter = (index: any, form_item: any) => {
      deleteBtnDict[index][form_item.field_name] = true;
    };
    const handleMouseLeave = (index: any, form_item: any) => {
      deleteBtnDict[index][form_item.field_name] = false;
    };
    const handleDeleteFormItem = (index: any, condition: any) => {
      //default_search_condition_config_list 不允许删除最后一个条件组的条件项
      const new_list = [];
      props.default_search_condition_config_list.forEach((item_list: any, index_: number) => {
        if (index_ !== index) {
          new_list.push(item_list);
        } else {
          const list = [];
          item_list.forEach((k: any) => {
            if (k.field_name !== condition.field_name) {
              list.push(k);
            }
          });
          if (list.length > 0) {
            new_list.push(list);
          }
        }
      });
      emit('update_default_search_condition_config_list', { new_list: new_list });
      // refreshCondition();
    };
    const handleDelSearch = (index, filed_name) => {
      if (condition_model_dict.value[index][filed_name] instanceof Array) {
        condition_model_dict.value[index][filed_name].length = 0;
      } else {
        condition_model_dict.value[index][filed_name] = null;
      }
      emit('onChangeValue', { model: condition_model_dict.value });
      emit('delSearch', { model: JSON.parse(JSON.stringify(condition_model_dict.value)) });
    };

    const onChangeSearchItem = (value: any, group_index, condition: any, condition_index) => {
      if (value instanceof Array && value.length > 0) {
        const selected_field_name = value[value.length - 1];
        let new_condition = null;
        props.base_search_condition_config_list.forEach(item_list => {
          item_list.group.forEach(i => {
            if (i.field_name === selected_field_name) {
              new_condition = JSON.parse(JSON.stringify(i));
              if (new_condition.default_operator) {
                new_condition.operator = new_condition.default_operator;
              } else if (get_operator_list_selected(new_condition).length > 0) {
                const [first] = get_operator_list_selected(new_condition);
                new_condition.operator = first;
              }
            }
          });
        });

        if (new_condition) {
          const new_list = JSON.parse(JSON.stringify(props.default_search_condition_config_list));
          new_list.forEach((item_list, i) => {
            if (i === group_index) {
              item_list.forEach((item, k) => {
                if (item.field_name == condition.field_name && k == condition_index) {
                  item_list.splice(k, 1, new_condition);
                  delete condition_model_dict.value[group_index][item.field_name];
                }
              });
            }
          });
          emit('update_default_search_condition_config_list', {
            new_list: new_list,
          });
        }
        refreshCondition();
      }
    };

    const searchItemOptionsDict: any = computed(() => {
      const dict = {};
      props.default_search_condition_config_list.forEach((group_item, index) => {
        dict[index] = [];
        const filter_field_name_list = group_item.map(item => item.field_name);
        props.base_search_condition_config_list.forEach(item => {
          const filter_list = item.group.filter(
            i => !filter_field_name_list.includes(i.field_name),
          );
          const o = {
            value: item.name,
            label: item.name,
            children: filter_list.map(i => {
              return {
                value: i.field_name,
                label: i.label,
              };
            }),
          };
          dict[index].push(o);
        });
      });
      return dict;
    });

    const isShowSearchTag = (index, condition) => {
      const value = condition_model_dict.value[index]?.[condition.field_name];
      if (value instanceof Array) {
        const [first] = value;
        if (isNotEmpty(first)) {
          return true;
        }
      } else if (isNotEmpty(value)) {
        return true;
      }
      return false;
    };

    const transferValueFunc = (index, condition) => {
      const str_list: any = [];
      const value = condition_model_dict.value[index]?.[condition.field_name];
      if (
        condition.operator === 'is_or_not_blank_or_null' ||
        condition.operator === 'is_or_not_null'
      ) {
        if (value === 'yes') {
          return t('is_or_not_blank_or_null.yes');
        } else {
          return t('is_or_not_blank_or_null.no');
        }
      } else if (condition.operator === '_eq') {
        if (['上月', '本月', '今日', '昨日', '期初'].includes(value)) {
          return t(value);
        }
      } else if (labelModel.value[condition.field_name] != undefined) {
        return `${get_operator_type_map(condition.format, condition.operator)} ${
          labelModel.value[condition.field_name]
        }`;
      } else if (value instanceof Array && condition.field_name_list instanceof Array) {
        let transfer_value;
        if (condition.field_name_list) {
          if (value instanceof Array) {
            transfer_value = value.join(',');
          } else {
            transfer_value = value;
          }
        }
        return `${get_operator_type_map(condition.format, condition.operator)} ${transfer_value}`;
      } else if (value instanceof Array && condition.options instanceof Array) {
        value.forEach(item => {
          condition.options.forEach(i => {
            if (item == i.value) {
              str_list.push(i.label);
            }
          });
        });
        return `${get_operator_type_map(condition.format, condition.operator)} ${str_list.join(
          ',',
        )}`;
      } else {
        let transfer_value;
        if (condition.options) {
          condition.options.forEach(i => {
            if (value == i.value) {
              transfer_value = i.label;
            }
          });
        } else if (condition.type == 'monthpicker' && condition.dateFormat) {
          if (value instanceof Array) {
            const str_list = [];
            value.forEach(i => {
              if (i) {
                str_list.push(moment(i).format(condition.dateFormat));
              } else {
                str_list.push(i);
              }
            });
            transfer_value = str_list.join(',');
          } else {
            transfer_value = moment(value).format(condition.dateFormat);
          }
        } else {
          transfer_value = value;
        }
        return `${get_operator_type_map(condition.format, condition.operator)} ${transfer_value}`;
      }
    };

    const handleShowSearchRender = () => {
      emit('onShowSearchRender');
    };

    const get_operator_list_selected = condition => {
      if (condition.operator_list_selected) {
        return condition.operator_list_selected;
      } else if (condition.operator_list) {
        return condition.operator_list;
      } else {
        return [];
      }
    };

    watch(
      () => condition_model_dict.value,
      () => {
        emit('onChangeValue', { model: condition_model_dict.value });
        // console.log('onChangeValue_watch');
      },
      { deep: true },
    );
    watch(
      () => props.default_search_condition_config_list,
      () => {
        if (props.default_search_condition_config_list?.length == 0) {
          emit('update_default_search_condition_config_list', {
            new_list: source_default_search_condition_config_list.value,
          });
          return;
        }
        refreshCondition();
      },
      { deep: true },
    );
    watch(
      () => props.base_search_condition_config_list,
      () => {
        refreshCondition();
      },
      { deep: true },
    );

    watch(
      () => props.is_clear_model,
      () => {
        if (props.is_clear_model) {
          condition_model_dict.value = {};
          refreshCondition();
          emit('update:is_clear_model', false);
        }
      },
    );
    onMounted(() => {
      refreshCondition();
      if (props.eventBus) {
        props.eventBus.on('filterChange', onFilterChanged);
      }
    });
    onUnmounted(() => {
      if (props.eventBus) {
        props.eventBus.off('filterChange', onFilterChanged);
      }
    });
    return {
      props,
      t,
      isShowForm,
      labelModel,
      get_operator_type_map,
      condition_model_dict,
      addConditionModal,
      handleAddConditions,
      handleAddConditionOk,
      handleAddConditionCancel,
      onChangeOperator,
      handleAddGroupCondition,
      handleSearch,

      addConditionGroupModal,
      handleAddGroupConditionOK,
      handleAddGroupConditionCancel,
      validateInfos,

      deleteBtnDict,
      handleMouseEnter,
      handleMouseLeave,
      handleDeleteFormItem,
      handleDelSearch,

      searchItemOptionsDict,
      onChangeSearchItem,
      transferValueFunc,
      isShowSearchTag,
      handleShowSearchRender,
      options_eq,
      get_operator_list_selected,
      is_or_not_blank_or_null_options,
    };
  },
});
</script>
<style lang="less" scoped>
.card {
  overflow: auto;
  max-height: 300px;
  background: #f2f5f7;
}

.condition-group {
  padding: 5px;
}

.range {
  margin-top: 5px;
}

.close-icon {
  width: 15px;
  margin-top: 5px;
  margin-left: 5px;
  color: red;
}

.search-bar {
  background: #f2f5f7;
  text-align: right;
}

:deep(.divider .ant-divider) {
  margin: 0;
}
</style>
